import type { CSSProperties, FC } from 'react';
import cn from 'classnames';
import Icon from '@/components/UI/Icon';
import TagsInput from '@/components/UI/TagsInput/TagsInput';
import styles from './TagSearch.module.scss';

const SEARCH_TAG_LIMIT = 5;

interface TagSearchProps {
  handleSearchInput: (tags: Array<string>) => void;
  searchQuery: Array<string>;
  searchPlaceholderText?: string;
  style?: CSSProperties;
  className?: string;
}

const TagSearch: FC<TagSearchProps> = ({
  handleSearchInput,
  searchQuery,
  searchPlaceholderText = '',
  style,
  className,
}) => (
  <div style={style} className={cn(className, 'relative')}>
    <span className="absolute z-5" style={{ top: '13px', left: '10px' }}>
      <Icon icon="search" width="24" height="24" />
    </span>
    <TagsInput
      className={cn(styles.tagSearchBar, 'ba b--gray bg-white')}
      value={searchQuery}
      onChange={handleSearchInput}
      placeholder={searchQuery.length < SEARCH_TAG_LIMIT ? searchPlaceholderText : ''}
      maxTags={SEARCH_TAG_LIMIT}
      onlyUnique
      insideTagsInput
      testId="tag-search"
    />
  </div>
);

export default TagSearch;
